import ConversationModel from 'Models/ConversationModel';
import { ConversationsFilterType } from './index.types';

/**
 * Checks if a conversation matches a given conversations list filter.
 * @param conversation - The conversation to check.
 * @param filter - The filter to check against.
 * @returns True if the conversation matches the given filter, false otherwise.
 */
export const doesConversationMatchFilter = (
  conversation: ConversationModel,
  filter: ConversationsFilterType
) => {
  switch (filter) {
    case 'all':
      return true;
    case 'unread':
      return conversation.unreadCount > 0;
    case 'group':
      return ['Channel', 'Group'].includes(conversation.grouping);
    case 'archived':
      return !!conversation.archived;
    default:
      return false;
  }
};
